import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { LoginModel } from '../../../model/login-model';
import { AuthService } from '../../../services/auth.service';
import { SharedModule } from '../../../shared/shared-module.ts.module';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [RouterModule, ReactiveFormsModule, SharedModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  loginForm: FormGroup;
  clientId: string | null = null;
  returnUrl: string | null = null;
  linkGoogleAfterLogin = false;
  errorMessage: string | null = null;

  constructor(
    private authService: AuthService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
  ) {
    this.clientId = this.authService.getClienteIdLocal();
    this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
    this.linkGoogleAfterLogin = this.route.snapshot.queryParamMap.get('linkGoogle') === 'true';
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email, Validators.maxLength(254)]],
      password: ['', [Validators.required, Validators.maxLength(128)]],
    });
  }



  login() {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }

    const clientId = this.authService.verificaClientId(this.clientId ?? '');
    if (clientId === null) {
      alert('Cliente invalido. Inicie o login pelo sistema que deseja acessar.');
      return;
    }

    if (!this.returnUrl) {
      alert('Contexto SSO invalido. Inicie o login pelo sistema que deseja acessar.');
      return;
    }

    this.spinner.show();
    this.errorMessage = null;
    const model: LoginModel = {
      email: this.loginForm.value.email.trim().toLowerCase(),
      password: this.loginForm.value.password,
      clientId,
      returnUrl: this.returnUrl,
    };

    this.authService.login(model).subscribe({
      next: (response) => {
        if (this.linkGoogleAfterLogin) {
          if (!this.returnUrl || !this.authService.isTrustedRedirect(this.returnUrl)) {
            this.spinner.hide();
            this.errorMessage = 'Contexto inválido. Reinicie o acesso pelo aplicativo.';
            return;
          }

          this.authService.startGoogleAccountLink(model.password, this.returnUrl).subscribe({
            next: (linkResponse) => {
              this.spinner.hide();
              if (this.authService.isGoogleAuthorizationUrl(linkResponse.authorizationUrl)) {
                window.location.assign(linkResponse.authorizationUrl);
              } else {
                this.errorMessage = 'Não foi possível iniciar o vínculo Google. Tente novamente.';
              }
            },
            error: () => {
              this.spinner.hide();
              this.errorMessage = 'Não foi possível iniciar o vínculo Google. Entre novamente e tente outra vez.';
            },
          });
          return;
        }

        const redirectUrl = response.redirectUrl;
        if (redirectUrl && this.authService.isTrustedRedirect(redirectUrl)) {
          this.spinner.hide();
          window.location.assign(redirectUrl);
        } else {
          this.spinner.hide();
          console.error('URL de redirecionamento não encontrada');
        }
      },
      error: () => {
        this.spinner.hide();
        this.errorMessage = 'Não foi possível confirmar a conta. Verifique suas credenciais e tente novamente.';
      },
    });
  }



}
